import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';
import { AuthService, MenuOption } from 'src/app/services/auth.service';

@Component({
    selector: '[app-menu]',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `
        <ul class="layout-menu">
            <ng-container *ngFor="let item of model; let i = index">
                <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
                <li *ngIf="item.separator" class="menu-separator"></li>
            </ng-container>
        </ul>
    `
})
export class AppMenu implements OnInit {

    model: any[] = []; // El modelo empieza vacío y se llenará dinámicamente

    constructor(private authService: AuthService) {}

    ngOnInit() {
        // Nos suscribimos para escuchar los permisos del menú
        this.authService.menuItems.subscribe(apiMenuItems => {
            if (apiMenuItems && apiMenuItems.length > 0) {
                this.model = this.buildMenuModel(apiMenuItems);
            } else {
                this.model = []; // Si no hay menú (logout), se vacía
            }
        });
    }

    // Esta función transforma la lista de la API en la estructura que el menú necesita
    private buildMenuModel(options: MenuOption[]): any[] {
        const menuModel = [];
        const moduleGroups = new Map<string, any>();
        menuModel.push({ label: 'MENU', isTitle: true });

        for (const option of options) {
            if (!moduleGroups.has(option.module_name)) {
                moduleGroups.set(option.module_name, {
                    label: option.module_name,
                    icon: this.getIconForModule(option.module_key),
                    items: []
                });
            }
            moduleGroups.get(option.module_name).items.push({
                label: option.option_name,
                icon: `pi pi-fw pi-${option.icon}`,
                routerLink: [option.route]
            });
        }

        const mainGroup = {
            label: '', // Dejamos el label principal vacío como en tu ejemplo original
            items: Array.from(moduleGroups.values())
        };

        menuModel.push(mainGroup);
        menuModel.push({ separator: true }); // Separador

        return menuModel;
    }

    private getIconForModule(moduleKey: string): string {
        switch (moduleKey) {
            case 'SC01': return 'pi pi-fw pi-book';
            case 'SC02': return 'pi pi-fw pi-users';
            default: return 'pi pi-fw pi-briefcase';
        }
    }
}
